import { Dialog } from "@/components/ui/Dialog";
import { BRAND } from "@/lib/tokens";
import { t } from "@/lib/strings";
import type { MemoMutations } from "@/hooks/useMemo";
import type { Memo } from "@/lib/types";

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  memo: Memo;
  mut: MemoMutations;
}

export function FinalizeMemoDialog({ open, onOpenChange, memo, mut }: Props) {
  const finalized = memo.status === "finalized";
  const pending = mut.finalize.isPending || mut.reopen.isPending;

  const act = () => {
    const m = finalized ? mut.reopen : mut.finalize;
    m.mutate(undefined, { onSuccess: () => onOpenChange(false) });
  };

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={finalized ? t.memoReopen : t.memoFinalize}
      description={finalized ? undefined : t.memoFinalizeConfirm}
      width={420}
    >
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          style={{
            border: "1px solid var(--hairline)",
            background: "transparent",
            borderRadius: 8,
            padding: "8px 14px",
            fontSize: 13,
            color: "var(--ink-2)",
            cursor: "pointer",
          }}
        >
          Abbrechen
        </button>
        <button
          type="button"
          onClick={act}
          disabled={pending}
          style={{
            background: BRAND.blue,
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "8px 16px",
            fontSize: 13,
            fontWeight: 600,
            cursor: pending ? "not-allowed" : "pointer",
            opacity: pending ? 0.6 : 1,
          }}
        >
          {finalized ? t.memoReopen : t.memoFinalize}
        </button>
      </div>
    </Dialog>
  );
}
